<template>
    <div class="flex items-center px-4 py-2 min-h-16">
        <slot></slot>
    </div>
</template>
